<template>
  <div>
    <label for>Tags</label>
    <v-combobox
      class="cross-chip"
      v-model="tagsModel"
      @keydown.space="preventEmptySpace"
      :items="[]"
      hide-selected
      multiple
      persistent-hint
      small-chips
      outlined
    >
      <template v-slot:selection="{ attrs, selected, item, parent }">
        <v-chip v-bind="attrs" :input-value="selected" label small>
          <span class="pr-2">{{ item }}</span>
          <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
        </v-chip>
      </template>
    </v-combobox>

    <span
      v-if="tagsModel.length === 0 && required"
      class="text-danger required-fields"
      >{{ requiredAlert }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    requiredAlert: {
      type: String,
      default: 'Please select at least one tag',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tagsModel: {
      get() {
        return this.tags;
      },
      set(value) {
        this.$emit("update:prop", value);
      },
    },
  },
};
</script>